import { useNavigate } from 'react-router-dom';
import React from 'react'
import "./sellernav.css"
import { useState } from 'react';
import { useEffect } from 'react';
const Sellernav = () => {
  var nav=useNavigate()
  var path=window.location.pathname
  const [search,setSeach]=useState("")
  function navigate(){
    nav('/Profile')
  }
  function navigateSellerPanel(){
    nav('/SellerPanel')
  }
  const handleKeyDown = (event) => {
    if (event.key === 'Enter' && !(path==='/SellerPanel/SalesReport')) {
       nav('/SearchResults', { state: { search: search} })
       window.location.reload()
    }
  }
  useEffect(() => {
    if(path==='/SellerPanel/SalesReport')
        searchProduct()
   },[search])
   const searchProduct=()=> {
    var nodes = document.getElementsByClassName('target');
    var i
    for (i = 0; i < nodes.length; i++) {
      var str=search.toLowerCase()
      if (nodes[i].innerText.toLowerCase().includes(str)) {
         if(nodes[i].style.display==="none")
             nodes[i].style=''
      } else {
        nodes[i].style.display = "none";
      }
    }
  }
  return (
    <>
    <div className='row navi gx-0'>
    <div className='col-lg-2 col-md-2 usernav'>
    <img src='https://res.cloudinary.com/vcart/image/upload/v1658298828/Screenshot__131_-removebg-preview_mtjdmd.png' style={{height:"30px", marginTop:"3px"}} alt="VCART" onClick={()=>navigateSellerPanel()}/>
    </div>
    <div className='col-lg-8 col-md-8'>
            <input className="searchUser" type="text" placeholder="Search for products, brand and more" name="search" value={search} 
      onChange={(e)=>setSeach(e.target.value)} onKeyDown={handleKeyDown}/>
    </div>
    <div className='col-lg-2  col-md-2 sellerIcons my-auto'>
    <a onClick={navigate}><i className="fas fa-user-circle mx-3"></i></a>
    <a onClick={navigateSellerPanel}><i className="fas fa-store mx-3"></i></a> 
    </div>
    </div>
    </>
  )
}

export default Sellernav